var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"subnav"},[_c('router-link',{staticClass:"btn btn-secondary btn-sm",attrs:{"to":"/creators/create"}},[_vm._v("Add creator")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }